import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import { baseAPI } from '../../services/baseAPI';

function AddKas() {
  const { id, npp } = useParams();
  const history = useHistory();
  const BENDAHARA = 5;
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(true);
  const [nominalTransaksi, setNominalTransaksi] = useState("NaN");
  const [newData, setNewData] = useState({
    aktivitas: "",
    deskripsi: "",
    debit: 0,
    kredit:0,
    nama_trx:"",
    kode_trx:"",
    submit_by:"",
    tgl_trx: moment(),
  });
  const [listAktivitas, setListAktivitas] = useState([
    { label: "Pemasukan", value: 1 },
    { label: "Pengeluaran", value: 2 },
  ]);
  const [jenisTransaksi, setJenisTransaksi] = useState();


  // CONTROLLER
  const fetchJenisTransaksi = async () => {

    await baseAPI
      .get(`/v1/kodetransaksi`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const jenis = res.data.data;
        let listJenis = [];
        jenis.forEach(e => {
          listJenis.push({ label: e.id + " - " + e.nama_transaksi, value: e.id })
        });
        setJenisTransaksi(listJenis);
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(`error ${error}`);
      })
  };

  const storeNewKas = async () => {
    
    Swal.fire({
      title: 'Do you want to save the data?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Save',
      denyButtonText: `Don't save`,
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        const body = new FormData();
        body.append('new_data', JSON.stringify(newData));

        baseAPI
          .post(`/v1/mutasikas`, body, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: "New mutasi has been added.",
              showConfirmButton: false,
              timer: 1500
            })
            console.log(`berhasil upload ${JSON.stringify(res)}`);
            history.push(`/kas/mutasikas`);;
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Failed add new mutasi.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setIsLoading(false);
          })
      } else if (result.isDenied) {
        Swal.fire('New mutasi is not added', '', 'info')
      }
    });

  };

  useEffect(() => {
    if (user.role === BENDAHARA) {
      fetchJenisTransaksi();
    };
  }, [token]);


  const handleFormat = (nominal) => {
    const numericValue = nominal.replace(/[^0-9]/g, '');
    const jumlah = parseFloat(numericValue).toLocaleString('id-ID');
    setNominalTransaksi(jumlah);
  }
  

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='#' style={{ color: '#333' }}>Kas</Link> /{' '}
              <Link to='/kas/addkas' style={{ color: '#333' }}>Tambah Mutasi Kas</Link>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const parsedDate = moment(newData.tgl_trx, "YYYY-MM-DD HH:mm:ss");
  const defaultDate = parsedDate.isValid() ? parsedDate.toDate() : null;

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Tambah Pencatatan Kas</b></p>
              </div>

              {/* Jenis Pencatatan */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Jenis Pencatatan
                </label>
                <Select
                  options={listAktivitas}
                  placeholder="Pilih jenis"
                  onChange={e => setNewData({...newData, aktivitas: e.value})}
                />
              </div>

              {/* GL Account */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  GL Account
                </label>
                <Select
                  options={jenisTransaksi}
                  placeholder="Pilih jenis"
                  onChange={e => setNewData({...newData, nama_trx: e.label, kode_trx: e.value})}
                />
              </div>

              {/* Pencatat */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Identitas Pencatat
                </label>
                <input
                  value={user.npp + " - Bendahara"}
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Tanggal transaksi */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Tanggal Transaksi
                </label>
                <DatePicker
                  readOnly
                  selected={defaultDate}
                  placeholderText="Pilih tanggal"
                  className="form-control datepicker"
                  dateFormat="dd/MM/yyyy"
                  onChange={(date) => {
                    // console.log("Selected Date:", date); // Add this line for debugging
                    setNewData({...newData, tgl_trx: date });
                  }}
                />
              </div>

              {/* Detail Transaksi */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Deskripsi Transaksi
                </label>
                <input
                  placeholder='Sebutkan detail transaksi'
                  className="form-control"
                  onChange={e => setNewData({...newData, deskripsi: e.target.value})}
                />
              </div>

              {/* Nominal Transaksi */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Nominal Transaksi
                </label>
                <input
                  placeholder='Sebutkan nominal transaksi'
                  value={nominalTransaksi === "NaN" || nominalTransaksi === null ? "Rp.0" : "Rp." + nominalTransaksi}
                  className="form-control"
                  onChange={e => {
                    handleFormat(e.target.value)
                    const numericValue = (e.target.value).replace(/[^0-9]/g, '')
                    newData.aktivitas == 1 ?
                    setNewData({...newData, kredit: numericValue})
                    :
                    setNewData({...newData, debit: numericValue})
                  }}
                />
              </div>

              <div className='col-md-12'>
                <button
                  disabled={newData.aktivitas !== "" && newData.nama_trx !== "" && newData.tgl_trx !== "" && newData.deskripsi !== "" && (nominalTransaksi > 0 || nominalTransaksi > 0) ? false : true}
                  type="button"
                  className='btn btn-danger col-md-12'
                  style={{backgroundColor: '#CD5C08'}}
                  onClick={() => storeNewKas()}
                >
                  Tambah
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}
      {/* {addView()} */}

    </div>
  );

}

export default AddKas;